import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { PulseLoader } from 'react-spinners';
import { FaUser } from 'react-icons/fa';
import { withAlert } from 'react-alert';

import {
  Content,
  Form,
  Label,
  Input,
  Button,
} from './styles';

class RecoveryModal extends Component {
  state = {
    loading: false,
    emailFocus: false,
    emailError: false,
  }

  openRecoveryModal = () => {
    this.setState({
      loading: false,
      emailFocus: false,
      emailError: false,
    });
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    await this.validateInputs();

    const { emailError } = this.state;

    if (!emailError) {
      this.setState({ loading: true, emailFocus: false });

      const { email } = this.state;

      this.props
        .recoveryPassword({
          variables: { email },
        })
        .then(() => {
          this.setState({ loading: false });
          this.props.close();
          this.props.success();
        })
        .catch((err) => {
          if (/email/i.test(err.message)) {
            this.setState({ loading: false });
            this.props.close();
            this.props.alert.error(`Nenhuma conta vinculada ao endereço de e-mail "${email}" foi encontrada`);
          }
        });
    }
  }

  validateInputs = () => {
    this.setState({ emailError: false });

    const { email } = this.state;

    const emailReg = /^[a-z0-9][a-z0-9-_.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/;
    if (!emailReg.test(email)) this.setState({ emailError: true });
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.type]: e.target.value });
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const {
      loading,
      emailFocus,
      emailError,
    } = this.state;

    const { open, close } = this.props;

    return (
      <Modal
        open={open}
        onClose={close}
        center
        ref={(ref) => { this.recoveryModal = ref; }}
      >
        <Content>
          <h2>Redefinir senha</h2>
          <p>
            {'Informe seu endereço de e-mail e enviaremos instruções para a redefinição da sua senha'}
          </p>
          <Form onSubmit={this.handleSubmit}>
            <Label
              error={emailError}
              onFocusInput={emailFocus}
            >
              <FaUser className="fa fa-user" />
              <Input
                type="email"
                placeholder="E-mail"
                onChange={this.handleInputChange}
                onFocus={() => this.onFocus('emailFocus')}
                onBlur={() => this.onBlur('emailFocus')}
              />
            </Label>
            <Button type="submit" disabled={loading}>
              {!loading ? (
                'Enviar'
              ) : (
                <PulseLoader
                  sizeUnit="px"
                  size={7}
                  color="#FFFFFF"
                  loading={loading}
                />
              )}
            </Button>
          </Form>
        </Content>
      </Modal>
    );
  }
}

export default withAlert()(RecoveryModal);
